import { useTranslation } from 'react-i18next'

/**
 * `t` bound to an explicit locale instead of the visitor's current language.
 *
 * Partner landing pages need this: a partner writes for one audience, and
 * mixing Hebrew body copy with English buttons looks broken. Shared components
 * embedded in such a page (the paywall plan panel) take the same locale so the
 * whole surface reads in one language.
 *
 * This deliberately does NOT call `i18n.changeLanguage`. That is global, and
 * would drag the sign-in and Metsikon modals — which render outside the route
 * and have no RTL layout — into a language the app cannot lay out. `lng` here
 * resolves through `getFixedT`, so the override stops at this subtree.
 *
 * Passing `undefined` falls back to the visitor's current language, which keeps
 * it a no-op for every existing caller.
 */
export function useLocalizedT(locale?: string) {
  const { t } = useTranslation(undefined, { lng: locale })
  return t
}
